export default {
  users: [],
  profiles: [],
  selectedUser: {},
  userProfiles: [],
  userProfilesUsers: [],
  invites: [],
  inviteDetails: {}
}
